import svgPaths from "../../imports/svg-aj18vyrf1e";

export function FigmaObligatoryRegistration() {
  return (
    <section className="bg-white py-8 md:py-12">
      <div className="container mx-auto px-4 max-w-[1560px]">
        <h2 className="text-[#101828] text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[36px] text-center mb-2">
          Registro obligatorio de patinetes eléctricos en España desde 2026
        </h2>
        <p className="text-[#4a5565] text-[13px] md:text-[16px] leading-[19px] md:leading-[24px] text-center mb-8 md:mb-12 max-w-[1505px] mx-auto px-4">
          Desde enero de 2026, el Gobierno ha activado oficialmente el Registro Nacional de Vehículos Personales Ligeros (VPL), gestionado por la Dirección General de Tráfico (DGT). Esta medida convierte el registro del patinete eléctrico en un requisito obligatorio y lo vincula directamente a la contratación de un seguro de Responsabilidad Civil.
        </p>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-[1000px] mx-auto">
          {/* Card 1 - Por qué es obligatorio */}
          <div className="bg-white border border-[#e5e7eb] rounded-[8px] p-5 md:p-6">
            <div className="bg-[#ff6900] rounded-full w-12 h-12 flex items-center justify-center mb-4">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24">
                <path d={svgPaths.p1adf7700} stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                <path d="M12 18H12.01" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
              </svg>
            </div>
            <h3 className="text-[#101828] text-[16px] md:text-[18px] font-semibold leading-[24px] md:leading-[27px] mb-4">
              ¿Por qué es obligatorio registrar un patinete eléctrico?
            </h3>
            <div className="text-[#4a5565] text-[13px] md:text-[14px] leading-[18px] md:leading-[20px] space-y-3">
              <p>
                Entre los objetivos de esta medida se encuentran: mejorar la seguridad vial y garantizar que los daños a terceros estén cubiertos en caso de accidente.
              </p>
              <p className="font-bold">El registro es obligatorio por varias razones clave:</p>
              <ul className="list-disc ml-5 space-y-1">
                <li>Permite identificar al propietario del patinete.</li>
                <li>Es un requisito imprescindible para contratar el seguro obligatorio.</li>
                <li>Da cumplimiento a la Ley 5/2025 de Responsabilidad Civil y seguro en la circulación de vehículos a motor.</li>
                <li>Facilita el control, la trazabilidad y la gestión de accidentes e infracciones.</li>
              </ul>
              <p className="font-bold">
                Sin registro no hay seguro, y sin seguro no se puede circular legalmente.
              </p>
            </div>
          </div>

          {/* Card 2 - Cómo registrar */}
          <div className="bg-white border border-[#e5e7eb] rounded-[8px] p-5 md:p-6">
            <div className="bg-[#ff6900] rounded-full w-12 h-12 flex items-center justify-center mb-4">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24">
                <path d={svgPaths.pb47f400} stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                <path d={svgPaths.p17a13100} stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                <path d="M10 9H8" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                <path d="M16 13H8" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                <path d="M16 17H8" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
              </svg>
            </div>
            <h3 className="text-[#101828] text-[16px] md:text-[18px] font-semibold leading-[24px] md:leading-[27px] mb-4">
              Cómo registrar un patinete eléctrico paso a paso
            </h3>
            <div className="text-[#4a5565] text-[13px] md:text-[14px] leading-[18px] md:leading-[20px] space-y-3">
              <p>El proceso para realizar el trámite es sencillo y principalmente digital.</p>
              
              <p className="font-bold">Acceder al registro por estas vías:</p>
              <ul className="list-disc ml-5 space-y-1">
                <li>A través de la sede electrónica de la DGT.</li>
                <li>Con ayuda telefónica en el 060.2.</li>
              </ul>

              <p className="font-bold">Prepara la documentación:</p>
              <p className="italic">Si el patinete está certificado:</p>
              <ul className="list-disc ml-5 space-y-1">
                <li>Datos del titular (o tutor legal, en caso de ser menor de edad).</li>
                <li>Número de certificado y número de serie.</li>
                <li>Ficha técnica del patinete.</li>
              </ul>

              <p className="italic">Si no está certificado:</p>
              <ul className="list-disc ml-5 space-y-1">
                <li>Datos del titular.</li>
                <li>Factura, ficha técnica o fotografía del patinete.</li>
              </ul>

              <p className="font-bold">Pagar la tasa administrativa</p>
              <p>El registro implica el pago de una tasa obligatoria a la DGT.</p>

              <p className="font-bold">Obtén certificado de inscripción</p>
              <p>La DGT emite un certificado digital con un número identificativo único (también llamado matrícula) que aparece en la parte superior de la etiqueta.</p>

              <p className="font-bold">Colocar la etiqueta identificativa</p>
              <p>Debe ir en el porta-identificador del patinete o en un lugar visible.</p>
            </div>
          </div>

          {/* Card 3 - Seguro obligatorio */}
          <div className="bg-white border border-[#e5e7eb] rounded-[8px] p-5 md:p-6">
            <div className="bg-[#ff6900] rounded-full w-12 h-12 flex items-center justify-center mb-4">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24">
                <path d={svgPaths.p3f3d8e00} stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
              </svg>
            </div>
            <h3 className="text-[#101828] text-[16px] md:text-[18px] font-semibold leading-[24px] md:leading-[27px] mb-4">
              ¿Debo contratar un Seguro de Patinete para poder circular?
            </h3>
            <div className="text-[#4a5565] text-[13px] md:text-[14px] leading-[18px] md:leading-[20px] space-y-3">
              <p>
                La respuesta es sí. El seguro de Responsabilidad Civil es obligatorio para los patinetes afectados por la norma y no se podrá contratar sin el registro previo.
              </p>
              <p>
                Este seguro cubre los daños personales y materiales a otras personas en caso de sufrir un accidente.
              </p>
              <p className="font-bold">¿Qué patinetes se ven afectados?</p>
              <p>Los patinetes que superen los 25 km/h o cuyo motor tenga más de 250 W.</p>
              <p className="font-bold">¿Qué multa me pueden poner?</p>
              <p>Circular sin seguro puede suponer multas de entre 500 y 800 €.</p>
              <p className="font-bold">¿Cómo contratar el seguro?</p>
              <p>Una vez obtengas el certificado de inscripción en la DGT con tu número de matrícula, podrás contratar el seguro de forma sencilla e inmediata con PCComponentes y Línea Directa.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}